import { SearchIndexCourseFilters } from '@shared/types';
import { FunctionComponent, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { RadioGroup } from '../RadioGroup';

export type LevelFilterProps = {
    value: SearchIndexCourseFilters['level'];
    onChange: (newValue: SearchIndexCourseFilters['level']) => void;
    renderOptionLabel?: (option: {
        value: NonNullable<SearchIndexCourseFilters['level']>;
        label: string;
        isSelected: boolean;
    }) => ReactNode;
};

const getLevelLabel = (level: SearchIndexCourseFilters['level']): string => {
    switch (level) {
        case 'All':
            return 'All Levels';
        case 'Beginner':
            return 'Beginner';
        case 'Intermediate':
            return 'Intermediate';
        case 'Advanced':
            return 'Advanced';
        default:
            return 'All Levels';
    }
};

const options: Array<NonNullable<SearchIndexCourseFilters['level']>> = [
    'All',
    'Beginner',
    'Intermediate',
    'Advanced',
];

export const LevelFilter: FunctionComponent<LevelFilterProps> = ({
    value,
    onChange,
    renderOptionLabel,
}) => {
    return (
        <RadioGroup<NonNullable<SearchIndexCourseFilters['level']>>
            className={styles.radioGroup}
            aria-label="Course level"
            options={options}
            onChange={onChange}
            value={value}
        >
            {(level, isSelected) => {
                const levelLabel = getLevelLabel(level);
                const label = renderOptionLabel
                    ? renderOptionLabel({
                          isSelected,
                          value: level,
                          label: levelLabel,
                      })
                    : levelLabel;
                const className = classNames({
                    [styles.option]: true,
                    [styles.selected]: isSelected,
                });
                return (
                    <div className={className} aria-label={levelLabel}>
                        <div className={styles.radio}>
                            <div className={styles.radioChecked}></div>
                        </div>
                        <span>{label}</span>
                    </div>
                );
            }}
        </RadioGroup>
    );
};

export default LevelFilter;
